import { Author } from '@models/author';
import { SlugEntityAdminApiService } from './slugEntityAdminApiService';

export class AuthorAdminService extends SlugEntityAdminApiService<Author> {
    constructor() {
        super('/api/admin/author');
    }
}
